import { useState } from 'react';
import { validateEmail } from '@shared/utils';
import { FORM_MESSAGES } from '@shared/constants';
import { apiClient, API_ENDPOINTS } from '@shared/services';

/**
 * Interactor (Business Logic) for Early Access Registration
 * Handles the core business logic for early access list
 */
export const useEarlyAccessInteractor = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    firstname: '',
    lastname: '',
    usecase: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const updateFormField = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const registerForEarlyAccess = async (data) => {
    // Validation
    if (!data.email || !validateEmail(data.email)) {
      throw new Error(FORM_MESSAGES.error.invalidEmail);
    }
    if (!data.usecase || data.usecase.trim() === '') {
      throw new Error('Veuillez décrire votre cas d\'usage');
    }

    // API call
    const response = await apiClient.post(API_ENDPOINTS.earlyAccess.register, {
      email: data.email,
      firstname: data.firstname,
      lastname: data.lastname,
      usecase: data.usecase,
    });

    return response;
  };

  const handleRegister = async () => {
    setIsSubmitting(true);
    setMessage({ type: '', text: '' });

    try {
      await registerForEarlyAccess(formData);
      setMessage({ type: 'success', text: FORM_MESSAGES.success.earlyAccess });
      setFormData({
        email: '',
        firstname: '',
        lastname: '',
        usecase: '',
      });
      setShowForm(false);
    } catch (error) {
      const errorMessage = error.message || FORM_MESSAGES.error.generic;
      setMessage({ type: 'error', text: errorMessage });
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    showForm,
    setShowForm,
    formData,
    updateFormField,
    isSubmitting,
    message,
    handleRegister,
  };
};
